import { render } from "./scorePage.vue?vue&type=template&id=0594127c"
import script from "./scorePage.vue?vue&type=script&lang=js"
export * from "./scorePage.vue?vue&type=script&lang=js"

import "./scorePage.vue?vue&type=style&index=0&id=0594127c&lang=scss"

import exportComponent from "C:\\Users\\stall\\Documents\\Projects\\Web Apps\\Small Projects\\gmscoreboard2021-primevue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__